export default __webpack_public_path__ + "static/media/edited-3.3eab0565.jpg";